import { BarChart3, LayoutList, Network } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import type { OrgView } from "./types";

interface ViewToggleProps {
  value: OrgView;
  onChange: (view: OrgView) => void;
  showDashboard?: boolean;
}

export function ViewToggle({ value, onChange, showDashboard = false }: ViewToggleProps) {
  return (
    <div className="inline-flex items-center rounded-md border bg-card shadow-sm p-0.5">
      <Button
        type="button"
        size="sm"
        variant="ghost"
        className={cn("gap-2 h-8", value === "chart" && "bg-accent text-accent-foreground")}
        onClick={() => onChange("chart")}
        data-testid="button-view-chart"
      >
        <Network className="h-4 w-4" />
        Organograma
      </Button>
      <Button
        type="button"
        size="sm"
        variant="ghost"
        className={cn("gap-2 h-8", value === "list" && "bg-accent text-accent-foreground")}
        onClick={() => onChange("list")}
        data-testid="button-view-list"
      >
        <LayoutList className="h-4 w-4" />
        Lista
      </Button>
      {showDashboard && (
        <Button
          type="button"
          size="sm"
          variant="ghost"
          className={cn("gap-2 h-8", value === "dashboard" && "bg-accent text-accent-foreground")}
          onClick={() => onChange("dashboard")}
          data-testid="button-view-dashboard"
        >
          <BarChart3 className="h-4 w-4" />
          Dashboard
        </Button>
      )}
    </div>
  );
}
